<template>
  <div class="registrationReport">
    <alert-basic
		:message="alert.message"
		:show="alert.show"
		:type="alert.type"
		@updateShow="updateShow"
    />

    <registration-report-selected-filter
		class="filter"
		:selectedFilters="selectedFilters"
		v-show="!showFilters"
    />

    <registration-report-filter
		@submit="getRegistrationReportData"
		@submitExcelExport="getRegistrationExcel"
		:appNameShort="appNameShort"
		v-show="showRegistrationFilters"
		:disableButtons="loadingData"
		:showFilters="showFilters"
		@filtersShallAppear="showFilters = true; showDataTable = false"
    />

    <registration-report-progress-bar :showSpinner="loadingData" />
	<v-overlay :value="loadingData"/>

    <registration-report-sum-section
		:summedData="registrationReportResultSummed"
		:showSumResults="showDataTable && registrationReportResult.length > 1"
		:currency="currencyCode"
		class="registratioReportSumSection"
    />

    <registration-report-table
		:bookings="registrationReportResult"
		:incompleteForms="registrationReportIncompleteForms"
		:selectedFilters="selectedFilters"
		v-show="showDataTable"
		class="registrationReportTable"
    />
  </div>
</template>

<script>
import axios from 'axios'
import AlertBasic from '../vueBasics/AlertBasic.vue'
import RegistrationReportFilter from './filter/RegistrationReportFilter.vue'
import RegistrationReportTable from './result/RegistrationReportTable.vue'
import RegistrationReportSelectedFilter from './RegistrationReportSelectedFilter.vue'
import RegistrationReportProgressBar from '../vueBasics/ProgressCircular.vue'
import RegistrationReportSumSection from './result/SumSection.vue'

export default {
	name: 'RegistrationReport',
	components: {
		AlertBasic,
		RegistrationReportFilter,
		RegistrationReportTable,
		RegistrationReportSelectedFilter,
		RegistrationReportProgressBar,
		RegistrationReportSumSection,
	},
	data() {
		return {
			showDataTable: false,
			selectedFilters: {},
			registrationReportResult: [],
			registrationReportResultSummed: [],
			registrationReportIncompleteForms: [],
			currencyCode: 'CHF',
			loadingData: false,
			showFilters: true,
			appNameShort: 'rs',
			showRegistrationFilters: true,
			alert: {
				type: 'info',
				show: false,
				message: '',
			},
		}
	},
	methods: {
		async getRegistrationReportData(filterOptions) {
			this.loadingData = true
			try {
				const resSum = await axios.post(
					// eslint-disable-next-line no-undef
					`${config.baseAPIurl}/registration-report/forms-sum`,
					{
						mandator: filterOptions.mandator,
						dateTill: filterOptions.dateTill,
						dateFrom: filterOptions.dateFrom,
						country: filterOptions.country,
						nationality: filterOptions.nationality,
						serviceprovider: filterOptions.serviceprovider,
						taxexemption: filterOptions.taxexemption,
						appNameShort: this.$data.appNameShort,
						kantons: filterOptions.kantons,
						status: filterOptions.status,
						serviceproviderCity: filterOptions.serviceproviderCity,
						serviceproviderAccommodationType:
						filterOptions.serviceproviderAccommodationType,
						resellerPartner: filterOptions.resellerPartner,
						resellerUser: filterOptions.resellerUser,
						arrivalBy: filterOptions.arrivalBy,
						checkInDates: filterOptions.checkInDates,
						checkOutDates: filterOptions.checkOutDates,
						nationalityIso: filterOptions.nationalityIso,
					},
				)
				const resCurrencyForInstallation = await axios.get(
					// eslint-disable-next-line no-undef
					`${config.baseAPIurl}/registration-report/currency`,
					{ params: { mandatorId: filterOptions.mandator[0].value } },
				)

				this.registrationReportResultSummed = resSum.data
				this.currencyCode = resCurrencyForInstallation.data

				const res = await axios.post(
					// eslint-disable-next-line no-undef
					`${config.baseAPIurl}/registration-report/forms`,
					{
						mandator: filterOptions.mandator,
						dateTill: filterOptions.dateTill,
						dateFrom: filterOptions.dateFrom,
						country: filterOptions.country,
						nationality: filterOptions.nationality,
						serviceprovider: filterOptions.serviceprovider,
						taxexemption: filterOptions.taxexemption,
						appNameShort: this.$data.appNameShort,
						kantons: filterOptions.kantons,
						status: filterOptions.status,
						serviceproviderCity: filterOptions.serviceproviderCity,
						serviceproviderAccommodationType:
						filterOptions.serviceproviderAccommodationType,
						resellerPartner: filterOptions.resellerPartner,
						resellerUser: filterOptions.resellerUser,
						arrivalBy: filterOptions.arrivalBy,
						checkInDates: filterOptions.checkInDates,
						checkOutDates: filterOptions.checkOutDates,
						nationalityIso: filterOptions.nationalityIso,
					},
				)

				this.registrationReportResult = res.data.groupedResults
				this.registrationReportIncompleteForms = res.data.incompleteForms
				this.selectedFilters = filterOptions
				this.showDataTable = true
				this.loadingData = false
				this.showFilters = false
			} catch (e) {
				this.loadingData = false
				if (e.response.data.message.includes('100000 forms exceeded')) {
					// eslint-disable-next-line max-len
					this.alert.message = `Requests are limited to 100.000 forms. The selected period contains ${this.formatNumber(
						e.response.data.value,
					)} forms. Please select a shorter period.`
					this.alert.show = true
					this.alert.type = 'info'
				} else {
					this.alert.show = true
					this.alert.message = 'Due to an error the the forms could not be loaded.'
					this.alert.type = 'error'
				}
				this.scrollToTop()
			}
		},
		async getRegistrationExcel(filterOptions) {
			this.loadingData = true;
			try {
				const response = await axios({
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/registration-report/excel`,
					method: 'post',
					responseType: 'blob',
					data: {
						mandator: filterOptions.mandator,
						dateTill: filterOptions.dateTill,
						dateFrom: filterOptions.dateFrom,
						country: filterOptions.country,
						nationality: filterOptions.nationality,
						serviceprovider: filterOptions.serviceprovider,
						taxexemption: filterOptions.taxexemption,
						appNameShort: this.$data.appNameShort,
						kantons: filterOptions.kantons,
						status: filterOptions.status,
						serviceproviderCity: filterOptions.serviceproviderCity,
						serviceproviderAccommodationType:
						filterOptions.serviceproviderAccommodationType,
						resellerPartner: filterOptions.resellerPartner,
						resellerUser: filterOptions.resellerUser,
						arrivalBy: filterOptions.arrivalBy,
						checkInDates: filterOptions.checkInDates,
						checkOutDates: filterOptions.checkOutDates,
						nationalityIso: filterOptions.nationalityIso,
					},
					headers: { Authorization: `Bearer ${this.$keycloak.token}` },
				});
				// eslint-disable-next-line max-len
				const filenameExtension = filterOptions.dateFrom === filterOptions.dateTill
					? filterOptions.dateFrom
					: `${filterOptions.dateFrom}-${filterOptions.dateTill}`
				// eslint-disable-next-line no-undef
				saveAs(
					new Blob([response.data]),
					`registrations_${filenameExtension}.xlsx`,
				)
			} catch (e) {
				console.log(e)
			}
			this.loadingData = false
		},
		updateShow(value) {
			this.alert.show = value
		},
		scrollToTop() {
			window.scrollTo(0, 0)
		},
		formatNumber(number) {
			return Number(number).toLocaleString('de')
		},
	},
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.filter {
  margin-top: 50px;
}

.registratioReportSumSection {
	margin-top: 40px;
	margin-bottom: 40px;
}

.registrationReportTable {
	margin-bottom: 50px;
}

</style>
